import "@kenshooui/react-multi-select/dist/style.css";
import React, { useState, useEffect, useRef } from "react";
import MultiSelect from "@kenshooui/react-multi-select";
import { fetchJson } from "../../lib/Fetching";

export default function TestnameInputMulti({ onChange }) {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const fetcher = useRef(null);

  const fetchData = (search) => {
    if (fetcher.current) {
      clearTimeout(fetcher.current);
    }
    if (search.length < 3) {
      setItems([]);
      return (item) => true;
    }
    fetcher.current = setTimeout(() => {
      fetchJson("/measurements.json", { search, ignore_internal: true }).then((testnames) =>
        setItems(
          testnames.map((t) => ({
            id: t.id,
            label: t.name,
          }))
        )
      );
    }, 300);
    return (item) => true;
  };

  return (
    <MultiSelect
      itemHeight={25}
      selectAllHeight={30}
      items={items}
      selectedItems={selectedItems}
      onChange={(items) => {
        setSelectedItems(items);
        onChange(items.map((i) => i.id));
      }}
      filterFunction={fetchData}
      height={180}
      responsiveHeight={"180px"}
    />
  );
}
